import axios from 'axios'
import {
    CommonSampleTypeResponse,
    SampleTypeWithCaseTypesResponse
} from '@/api/services/common/sample-type/common-sample-type.dto'

class CommonSampleTypeService {
    async getSampleTypes(): Promise<CommonSampleTypeResponse[]> {
        const response = await axios.get<CommonSampleTypeResponse[]>(`/common/sampleTypes/`)
        return response.data
    }

    async getSampleTypesWithCaseTypes(laboratoryId: number, sampleTypeIds: number[]): Promise<SampleTypeWithCaseTypesResponse[]> {
        const response = await axios.get<SampleTypeWithCaseTypesResponse[]>(`/common/sampleTypes/withCaseTypes`, { params: { laboratoryId, sampleTypeIds } })
        return response.data
    }
}

export const commonSampleTypeService = new CommonSampleTypeService()
